import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "../auth.service";
import {tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class InternalGuard implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.isInternal()
      .pipe(
        tap(internal => {
          if (!internal) {
            this.router.navigate(['/download']);
          }
        })
      );
  }

}
